import "./App.css";
import Dashboard from "./Component/Dashboard";
import { useState, useEffect } from "react";

import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Member from "./Component/Innercontent/Member";
import Login from "./Component/login";
import Order from "./Component/Innercontent/Order";
import Agent from "./Component/Innercontent/Agent";
import Limitnumber from "./Component/Innercontent/Limitnumber";
import Winlose from "./Component/Innercontent/Winlose";
import WinloseDetail from "./Component/Innercontent/WinloseDetail";
import OutstandingDetail from "./Component/Innercontent/OutstandingDetail";
import Paidhistory from "./Component/Innercontent/Paidhistory";
import Lottoresult from "./Component/Innercontent/Lottoresult";
import LottoService from "./Component/Innercontent/LottoService";
import AgentEdit from "./Component/Innercontent/AgentEdit";
import AgentAdd from "./Component/Innercontent/AgentAdd";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Fightlimitmax from "./Component/Innercontent/Fightlimitmax";
import Loginslog from "./Component/Innercontent/Loginlogs";
import ActivityLog from "./Component/Innercontent/ActivityLog";
import Waitresult from "./Component/Innercontent/Waitresult";
import Commission from "./Component/Innercontent/commission";
import Reward from "./Component/Innercontent/cReward";
import Maxbet from "./Component/Innercontent/cMaxbet";
import Subaccount from "./Component/Innercontent/Subaccout";
import Maxbetpermatch from "./Component/Innercontent/cMaxbetpermatch";
import Minbet from "./Component/Innercontent/cMinbet";
import Forbidden from "./Component/Innercontent/Forbidden";
import CommissionReward from "./Component/Innercontent/commission-reward";
import LottoType from "./Component/Innercontent/LottoType";
import Schedule from "./Component/Innercontent/Schedule";
import MemberTopUp from "./Component/Innercontent/MemberTopUp";
import MemberTopupReport from "./Component/Innercontent/MemberTopupReport";
import AgentTopupReport from "./Component/Innercontent/AgentTopupReport";
import MemberWithdraw from "./Component/Innercontent/MemberWithdraw";
import LottoWaitResultUserPage from "./Component/Innercontent/LottoWaitResultUserPage";
import LottoWaitResultTypePage from "./Component/Innercontent/LottoWaitResultTypePage";
import LottoBetPage from "./Component/Innercontent/LottoBetPage";
import Settings from "./Component/Innercontent/Settings";
import { Button } from "@mui/material";
import ApiConfig from "./common/config/ApiConfig";

function App() {
  const [Auth, setAuth] = useState(false);
  const [loading, setLoading] = useState(true);
  const [permission, setPermission] = useState({
    edit_lotto_status: 0,
    limit_lotto: 0,
    edit_maxfight: 0,
    winlose_view: 0,
    result_view: 0,
    waitresult_view: 0,
    waitresultuser_view: 0,
    waitresulttype_view: 0,
    lottobet_view: 0,
    edit_agent: 0,
    edit_member: 0,
    add_agent: 0,
  });
  const pos = localStorage.getItem("position");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      // No token at all (never logged in, or storage was cleared) — same
      // "return here after login" capture as the /authen failure branches
      // below, so visiting a deep link cold (or testing "expired" by
      // clearing localStorage.token directly) still round-trips back here.
      if (window.location.pathname !== "/login") {
        sessionStorage.setItem(
          "postLoginRedirect",
          window.location.pathname + window.location.search,
        );
      }
      setLoading(false);
      return;
    }
    fetch(`${process.env.REACT_APP_API_KEY}/authen`, {
      method: "get",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((data) => data.json())
      .then((data) => {
        if (data.resCode === 200) {
          localStorage.setItem("user", data.data.username);
          localStorage.setItem("position", data.data.position);
          localStorage.setItem("subuser", data.data.sub_username);
          localStorage.setItem("subuserid", data.data.sub_id);
          setAuth(true);
        } else {
          localStorage.removeItem("user");
          localStorage.removeItem("position");
          localStorage.removeItem("token");
          localStorage.removeItem("subuser");
          localStorage.removeItem("subuserid");
          // Same "return here after login" capture as ApiConfig's 401
          // handler — this mount-time /authen check is a raw fetch() that
          // bypasses ApiConfig entirely, so a token that's already expired
          // BEFORE any other API call happens (e.g. the user just refreshed
          // a deep page) would otherwise never get captured, and login.jsx
          // would fall back to "/".
          if (window.location.pathname !== "/login") {
            sessionStorage.setItem(
              "postLoginRedirect",
              window.location.pathname + window.location.search,
            );
          }
          setAuth(false);
          setLoading(false);
        }
      })
      .catch(() => {
        localStorage.removeItem("user");
        localStorage.removeItem("position");
        localStorage.removeItem("token");
        localStorage.removeItem("subuser");
        localStorage.removeItem("subuserid");
        if (window.location.pathname !== "/login") {
          sessionStorage.setItem(
            "postLoginRedirect",
            window.location.pathname + window.location.search,
          );
        }
        setAuth(false);
        setLoading(false);
      });
  }, []);

  const getpermission = () => {
    const id = localStorage.getItem("subuserid");
    ApiConfig.get("/getpermissionid", { id })
      .then((data) => {
        if (data.resCode === 200 && data.data && data.data.length >= 1) {
          setPermission(data.data[0]);
        } else {
          setPermission({
            edit_lotto_status: 1,
            limit_lotto: 1,
            edit_maxfight: 1,
            winlose_view: 1,
            result_view: 1,
            waitresult_view: 1,
            waitresultuser_view: 1,
            waitresulttype_view: 1,
            lottobet_view: 1,
            edit_agent: 1,
            edit_member: 1,
            add_agent: 1,
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (Auth) {
      getpermission();
    }
  }, [Auth]);

  if (loading) {
    return <div>Loading...</div>;
  } else {
    if (!Auth) {
      return <Login />;
    } else {
      return (
        <div className="App">
          <BrowserRouter
            future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
          >
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
            {/* Same as */}
            <ToastContainer />
            <Routes>
              <Route
                path="/*"
                element={
                  <div className="text-center">
                    <h1 className="text-4xl md:text-6xl font-bold text-gray-800 mb-6">
                      404 Page Not Found
                    </h1>
                    <Button
                      href="/"
                      className="px-4 py-2 text-sm md:text-base bg-brand-blue-500 text-white rounded hover:bg-brand-blue-600"
                    >
                      Go Home
                    </Button>
                  </div>
                }
              ></Route>
              <Route path="/" element={<Dashboard />}></Route>
              <Route path="/member" element={<Member />}></Route>
              <Route path="/order" element={<Order />}></Route>
              <Route path="/loginlogs" element={<Loginslog />}></Route>
              <Route path="/activitylog" element={<ActivityLog />}></Route>
              <Route path="/agent" element={<Agent />}></Route>
              <Route path="/forbidden" element={<Forbidden />}></Route>

              {pos === "sub_account" ? (
                <Route path="/subaccount" element={<Forbidden />}></Route>
              ) : (
                <Route path="/subaccount" element={<Subaccount />}></Route>
              )}

              {pos === "owner" ? (
                <Route path="/lotto-service" element={<LottoService />}></Route>
              ) : (
                <Route path="/lotto-service" element={<Forbidden />}></Route>
              )}
              {permission.limit_lotto === 1 ? (
                <Route path="/limitnumber" element={<Limitnumber />}></Route>
              ) : (
                <Route path="/limitnumber" element={<Forbidden />}></Route>
              )}
              {permission.edit_maxfight === 1 ? (
                <Route
                  path="/fightlimitmax"
                  element={<Fightlimitmax />}
                ></Route>
              ) : (
                <Route path="/fightlimitmax" element={<Forbidden />}></Route>
              )}
              {permission.winlose_view === 1 ? (
                <Route path="/winlose" element={<Winlose />}></Route>
              ) : (
                <Route path="/winlose" element={<Forbidden />}></Route>
              )}
              {permission.winlose_view === 1 ? (
                <Route
                  path="/winlose-detail"
                  element={<WinloseDetail />}
                ></Route>
              ) : (
                <Route path="/winlose-detail" element={<Forbidden />}></Route>
              )}
              {permission.result_view === 1 ? (
                <Route path="/lottoresult" element={<Lottoresult />}></Route>
              ) : (
                <Route path="/lottoresult" element={<Forbidden />}></Route>
              )}
              {/* No permission.*_view gate — the /getmembertopupreport
                  backend route itself has no checkPermission either, same
                  as the rest of the member_topup module. */}
              <Route
                path="/membertopup-report"
                element={<MemberTopupReport />}
              ></Route>
              {/* Same reasoning as membertopup-report above — the
                  /getagenttopupreport route has no checkPermission either. */}
              <Route
                path="/agenttopup-report"
                element={<AgentTopupReport />}
              ></Route>
              {permission.edit_agent === 1 ? (
                <Route path="/agentedit" element={<AgentEdit />}></Route>
              ) : (
                <Route path="/agentedit" element={<Forbidden />}></Route>
              )}
              {permission.add_agent === 1 ? (
                <Route path="/agentadd" element={<AgentAdd />}></Route>
              ) : (
                <Route path="/agentadd" element={<Forbidden />}></Route>
              )}
              {permission.waitresult_view === 1 ? (
                <Route path="/lottowaitresult" element={<Waitresult />}></Route>
              ) : (
                <Route path="/lottowaitresult" element={<Forbidden />}></Route>
              )}
              {permission.waitresultuser_view === 1 ? (
                <Route
                  path="/lottowaitresultuser"
                  element={<LottoWaitResultUserPage />}
                ></Route>
              ) : (
                <Route
                  path="/lottowaitresultuser"
                  element={<Forbidden />}
                ></Route>
              )}
              {permission.waitresultuser_view === 1 ? (
                <Route
                  path="/outstanding-detail"
                  element={<OutstandingDetail />}
                ></Route>
              ) : (
                <Route
                  path="/outstanding-detail"
                  element={<Forbidden />}
                ></Route>
              )}
              {permission.waitresulttype_view === 1 ? (
                <Route
                  path="/lottowaitresulttype"
                  element={<LottoWaitResultTypePage />}
                ></Route>
              ) : (
                <Route
                  path="/lottowaitresulttype"
                  element={<Forbidden />}
                ></Route>
              )}
              {permission.lottobet_view === 1 ? (
                <Route path="/lottobet" element={<LottoBetPage />}></Route>
              ) : (
                <Route path="/lottobet" element={<Forbidden />}></Route>
              )}
              {permission.edit_agent === 1 ? (
                <Route path="/commission" element={<Commission />}></Route>
              ) : (
                <Route path="/commission" element={<Forbidden />}></Route>
              )}
              {permission.edit_agent === 1 ? (
                <Route path="/member-top-up" element={<MemberTopUp />}></Route>
              ) : (
                <Route path="/member-top-up" element={<Forbidden />}></Route>
              )}
              {permission.edit_agent === 1 ? (
                <Route
                  path="/member-withdraw"
                  element={<MemberWithdraw />}
                ></Route>
              ) : (
                <Route path="/member-withdraw" element={<Forbidden />}></Route>
              )}
              {permission.edit_agent === 1 ? (
                <Route path="/reward" element={<Reward />}></Route>
              ) : (
                <Route path="/commission" element={<Forbidden />}></Route>
              )}
              {permission.edit_agent === 1 ? (
                <Route path="/maxbet" element={<Maxbet />}></Route>
              ) : (
                <Route path="/commission" element={<Forbidden />}></Route>
              )}
              {permission.edit_agent === 1 ? (
                <Route path="/minbet" element={<Minbet />}></Route>
              ) : (
                <Route path="/minbet" element={<Forbidden />}></Route>
              )}
              {permission.edit_agent === 1 ? (
                <Route
                  path="/maxbetpermatch"
                  element={<Maxbetpermatch />}
                ></Route>
              ) : (
                <Route path="/maxbetpermatch" element={<Forbidden />}></Route>
              )}
              {pos === "owner" ? (
                <Route
                  path="/setting/commission-reward"
                  element={<CommissionReward />}
                ></Route>
              ) : (
                <Route
                  path="/setting/commission-reward"
                  element={<Forbidden />}
                ></Route>
              )}
              {pos === "owner" ? (
                <Route
                  path="/setting/lotto-type"
                  element={<LottoType />}
                ></Route>
              ) : (
                <Route
                  path="/setting/lotto-type"
                  element={<Forbidden />}
                ></Route>
              )}
              {pos === "owner" ? (
                <Route path="/setting/schedule" element={<Schedule />}></Route>
              ) : (
                <Route path="/setting/schedule" element={<Forbidden />}></Route>
              )}
              {pos === "owner" ? (
                <Route path="/settings" element={<Settings />}></Route>
              ) : (
                <Route path="/settings" element={<Forbidden />}></Route>
              )}
            </Routes>
          </BrowserRouter>
        </div>
      );
    }
  }
}

export default App;
